// extracted by mini-css-extract-plugin
export default {"infoPage":"styles_infoPage__nfhTG","title":"styles_title__uWO92"};